module.exports = __webpack_public_path__ + "img/cl.174eee37.svg";